export class WdPostSearchResults {
    results;
    constructor(response) {
        this.results = response.results;
    }
}
//# sourceMappingURL=post-experimental-search.js.map